import {
  ParamsToFilterReferringCompanies,
  ReferringCompany,
} from '@/modules/leadIndication/entities/leadIndication.interface';
import EligibilityService from '@/modules/leadIndication/services/eligibilityService';
import { BaseListResponseWithKeysetPagination } from '@/shared/entities';
import { useRequestKeysetPaginatedList } from '@/shared/hooks/useRequestData/useRequestKeysetPaginatedList';

const eligibilityService = new EligibilityService();

/**
 * Carrega a lista de empresas indicadoras disponíveis para seleção/filtro no fluxo.
 *
 * Reaproveita `useRequestPaginatedList` para suportar paginação e filtros
 * (nome, documento, status ou companyGroupId, conforme contrato).
 */
const useReferringCompanies = (paramsToFilter?: Partial<ParamsToFilterReferringCompanies>) => {
  const {
    data: referringCompanies,
    loading,
    pageSize,
    hasNextPage,
    hasPreviousPage,
    startCursor,
    endCursor,
    loadData,
    refreshData,
    goToNextPage,
    goToPreviousPage,
  } =
    useRequestKeysetPaginatedList<ReferringCompany, ParamsToFilterReferringCompanies>({
      source: (filters) =>
        eligibilityService.getReferringCompanies<BaseListResponseWithKeysetPagination<ReferringCompany>>(filters),
      autoLoad: true,
      paramsToFilter,
    });

  return {
    referringCompanies,
    loading,
    pageSize,
    hasNextPage,
    hasPreviousPage,
    startCursor,
    endCursor,
    loadData,
    refreshData,
    goToNextPage,
    goToPreviousPage,
  };
};

export default useReferringCompanies;
